var ytPlayer;

var isIphone = false;
var isIpad = false;


if((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i))) {
    isIphone = true;
}

if (navigator.userAgent.match(/iPad/i)) {
    isIpad = true;
}

function onYouTubePlayerAPIReady() {
    ytPlayer = new YT.Player('ytplayer', {

        playerVars: {
            'rel': 0
        }
    });
}


(function ($) {

    if (isIphone) {
        $('.top-banner .video-background, video').remove();
    }
    
    if (isIpad) {
        $('.page-block.video-block video').remove();
    }

    //************************************
    // RESIZE VIDEO
    //************************************

    function vidRescale() {

        $('.video-background').each(function () {

            var _width = $(this).width();
            var _height = $(this).height();

            var _ratio_x = $(this).data('ratio-x');
            var _ratio_y = $(this).data('ratio-y');

            var _video = $(this).find('video');

            if (_width / _height > _ratio_x / _ratio_y) {

                _video.css({
                    "width": _width,
                    "height": _width / _ratio_y * _ratio_x
                });


            } else {

                _video.css({
                    "width": _height / _ratio_y * _ratio_x,
                    "height": _height
                });
            }

        });

    }

    $(window).on('resize load', function () {
        vidRescale();
    });

    var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
    var isIE10 = false;

    /*@cc_on
     if (/^10/.test(@_jscript_version)) {
     isSafari = true;
     isIE10 = true;
     }
     @*/

    if (Modernizr.touch) {
        $('body').addClass('touch');
    }

    $(window).on('load', function () {


        if ($('body').hasClass('home')) {

            $('#preloader').fadeOut(500);

            $('.pages-list .video-background video, .top-banner .video-background video').each(function () {
                $(this).get(0).play();
            });
        }


        function getSlug(href) {

            var l = document.createElement("a");

            l.href = href;

            return l.pathname.replace(/^\/|\/$/g, '');

        }

        // function changeURL() {
        //     var theURL = window.location.pathname;
        //     return theURL.replace("/waste-management-commission/", "/new/");
        // }


        if ($('.particles-slider').length) {

            var path = window.location.pathname;

            var rootPath = path.substring(0, path.lastIndexOf('/'));


            var slug = path.split("/").pop().split('.html')[0];

            var slideIndex = $('.left-side .parts-slider .slide-item[data-slug=' + slug + ']').index() + 1;

            var slider = new Slider({});

            slider.create();

            slider.setSlide(slideIndex);

            $('.navbar-nav').on('click', 'a', function (event) {

                var _ = $(this);
                var _wrap = _.closest('li');

                if (_wrap.hasClass('slider-page')) {

                    var ww = $(window).width();

                    var _href = _.attr('href');

                    var _slug = _href.split('.html')[0];

                    var _hash = '#' + _href.split("#")[1];



                    event.preventDefault();
                    $("#navbar").collapse('hide');

                    if (_wrap.hasClass('current-menu-item')) {

                        if (_wrap.hasClass('anchor-link')) {

                            if ($(_hash).length) {
                                $('html, body').animate({
                                    scrollTop: $(_hash).offset().top
                                }, 500);

                                location.hash = _hash;
                            }

                            return;
                        }

                        return;
                    }

                    $('.menu-item').removeClass('current-menu-item');

                    _wrap.addClass('current-menu-item');
                    _wrap.find('.sub-menu li').addClass('current-menu-item');


                    if (_wrap.hasClass('anchor-link')) {
                        var subMenu = _wrap.closest('.sub-menu');
                        subMenu.find('li').addClass('current-menu-item');
                    }


                    window.history.pushState("", "", rootPath + "/" + _href);

                    var slideIndex = $('.left-side .parts-slider .slide-item[data-slug=' + _slug + ']').index() + 1;


                    $('html').animate({scrollTop: 0}, 300);

                    $('body').animate({scrollTop: 0}, 300, function () {

                        if (ww <= 1024) {
                            slider.setSlide(slideIndex);
                        }

                        else {
                            slider.goToSlide(slideIndex);
                        }
                    });

                }

            })

        }


        function Slider(settings) {

            var animationInProgress = false;

            var currentSlide = 1;

            var leftSlider, rightSlider;

            var SLIDES_NUMBER = $('.sides-wrap').data('slides-num');

            $('body').on('scroll mousewheel touchmove', function (e) {
                if (animationInProgress) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
            });

            this.create = function () {

                leftSlider = new GridSlider({
                    selector: '.left-side .parts-slider',
                    extraColsSide: 'left'
                });

                leftSlider.create();


                rightSlider = new GridSlider({
                    selector: '.right-side .parts-slider',
                    extraColsSide: 'right'
                });

                rightSlider.create();


                createTitles();


                $('.controls').on('click', 'button', function () {

                    var direction = $(this).data('direction');
                    var ww = $(window).width();


                    $('html').animate({scrollTop: 0}, 300);

                    $('body').animate({scrollTop: 0}, 300, function () {

                        if (ww <= 1024) {
                            if (direction == 'prev') {
                                slider.setPrevSlide();
                            }

                            else {
                                slider.setNextSlide();
                            }
                        }

                        else {
                            if (direction == 'prev') {
                                slider.prevSlide();
                            }

                            else {
                                slider.nextSlide();
                            }
                        }
                    });

                });

            };


            this.nextSlide = function () {

                changeSlide({
                    data: {
                        message: 'next'
                    }
                });


            };


            this.prevSlide = function () {

                changeSlide({
                    data: {
                        message: 'prev'
                    }
                });


            };

            this.goToSlide = function (slide) {

                changeSlide({
                    data: {
                        message: 'index',
                        index: parseInt(slide)
                    }
                });


            };


            this.setNextSlide = function () {

                changeSlide({
                    data: {
                        message: 'next',
                        noAnimation: true
                    }
                });


            };


            this.setPrevSlide = function () {

                changeSlide({
                    data: {
                        message: 'prev',
                        noAnimation: true
                    }
                });


            };


            this.setSlide = function (slide) {

                changeSlide({
                    data: {
                        message: 'index',
                        index: parseInt(slide),
                        noAnimation: true
                    }
                });


            };

            function createTitles() {


                $('.overflow .title').each(function () {

                    var _title = $(this);

                    var _titleInner = _title.find('.line');


                    _titleInner.each(function () {

                        var _lineInner = $(this);

                        var mySplitText = new SplitText(_lineInner, {type: "chars"});


                    });
                });

            }


            function changeSlide(event) {

                switch (event.data.message) {
                    case 'prev':

                        if (currentSlide == 1) {
                            currentSlide = SLIDES_NUMBER;
                        }

                        else {
                            currentSlide--;
                        }

                        break;

                    case 'next':
                        if (currentSlide == SLIDES_NUMBER) {
                            currentSlide = 1;
                        }
                        else {
                            currentSlide++;
                        }

                        break;

                    case 'index':

                        currentSlide = event.data.index;

                        break;

                    default:
                        return;
                }


                var nextSlide = currentSlide;


                //update url if prev on next
                if (event.data.message != 'index') {

                    var nextSlug = $('.left-side .parts-slider .slide-item:eq(' + (nextSlide - 1) + ')').attr('data-slug');

                    window.history.pushState("", "", rootPath + "/" + nextSlug + ".html");

                }

                if (event.data.noAnimation) {
                    $('.animation-col').addClass('noAnimation');

                    hideContent();

                    leftSlider.animateGridCols(nextSlide);
                    rightSlider.animateGridCols(nextSlide);

                    setTimeout(function () {
                        playVideo();
                    }, 500)
                }

                else {

                    var currentTitle = $('.overflow .title:eq(' + (nextSlide - 1) + ')');

                    currentTitle.addClass('active');

                    $('body').addClass('animate');

                    animationInProgress = true;

                    var tl = new TimelineMax({
                        onComplete: slideColAnimation
                    });


                    tl

                        .to('.content-slider', 0.5, {className: '+=hideContent'})

                        .set('.sides-wrap', {className: '+=will-change'})
                        .set('.overflow', {className: '+=will-change'})

                        .to('.right-side .bottom-part', 0.5, {height: rightSlider.COLOR_PARTS_ROWS * leftSlider.blockHeight})
                        .to('.left-side .bottom-part', 0.5, {height: leftSlider.COLOR_PARTS_ROWS * rightSlider.blockHeight}, '-=0.5')


                        // .to('.cols-wrap', 1, {autoAlpha: 1, display:'block'})
                        .to('.cols-wrap', 0.5, {className: '+=active'})

                        // .set('.content-slider', {className: '+=hide'})

                        // .set('.content-slider', 0, {opacity: 0})


                        .set('.content-slider .item', {className: '-=active'})
                        .set('.slide-item', {className: '-=active'})


                        // .to('.sides-wrap', 1.2, {scale: 0.5}, '-=0.5')


                        .to('.sides-wrap', 1.2, {className: '+=scale'}, '-=0.5')

                        .to('.overflow', 1.2, {display: 'block'}, '-=1.2')
                        .to('.overflow', 1.2, {className: '+=active'}, '-=1.2')

                        .set('.block.shifted', {className: '-=shifted'})
                        .set('.block', {x: '0'})


                    // .addLabel("titleAnimate", "+=0")
                    //

                    // .staggerFrom(chars, 0.9, {y: 60,  ease:Back.easeOut}, 0.001, "titleAnimate")

                }


                function slideColAnimation() {

                    //stop video
                    stopVideo();

                    currentTitle.each(function () {

                        var _lineInner = $(this).find('.line-inner');

                        var _chars = _lineInner.find('>div');

                        // var chars = mySplitText.chars;


                        TweenMax.staggerTo(_chars, 0.5, {y: '-100%'}, 0.5 / _chars.length)

                    });

                    // TweenMax.staggerTo(chars, 0.5, {y: '-100%'}, 0.5 / chars.length)


                    leftSlider.animateGridCols(nextSlide);
                    rightSlider.animateGridCols(nextSlide);

                    setTimeout(titleFadeOut, 1900);
                    setTimeout(slideColAnimationEnd, 2000);
                }


                function titleFadeOut() {
                    currentTitle.each(function () {

                        var _lineInner = $(this).find('.line-inner');

                        var _chars = _lineInner.find('>div');

                        TweenMax.staggerTo(_chars, 0.5, {y: '-200%'}, 0.3 / _chars.length)

                    });
                }


                function slideColAnimationEnd() {

                    var tl = new TimelineMax({
                        onComplete: slideColAnimationEnded
                    });

                    var currentSlideItem = $('.slides-list .slide-item:nth-child(' + nextSlide + ')');
                    var currentContentItem = $('.content-slider .item:nth-child(' + nextSlide + ')');

                    var bottomPartHeightValue = '';

                    if (isSafari) {
                        bottomPartHeightValue = 'auto';
                    }

                    else {
                        bottomPartHeightValue = '100%'
                    }

                    tl

                        .set('.sides-wrap', {className: '-=scale'})

                        .to('.overflow', 1, {className: '-=active'}, '-=2')
                        .set('.overflow', {display: 'none'})
                        .set('.overflow', {className: '-=will-change'})

                        .set('.sides-wrap .bottom-part', {height: bottomPartHeightValue}, '-=0.5')

                        // .to('.sides-wrap .content-slider', 0.5, {opacity: 1}, '-=0.5')

                        // .set('.content-slider', {className: '-=hide'})

                        .set(currentSlideItem, {className: '+=active'})
                        .set(currentContentItem, {className: '+=active'})

                        .set('.cols-wrap', {className: '-=active'}, '+=0.5')

                        .set('.sides-wrap', {className: '-=will-change'})

                        .set('.content-slider', {className: '-=hideContent'})


                        .set('body', {className: '-=animate'})

                        .set('.overflow .line-inner >div', {clearProps: 'y'})
                        .set('.overflow .title', {className: '-=active'})

                }

                function playVideo() {
                    if ($('.slide-item.active .video-background video').length) {

                        $('.slide-item.active .video-background video').get(0).play();
                    }
                }

                function stopVideo() {
                    if ($('.slide-item .video-background video').length) {
                        $('.slide-item .video-background video').get(0).pause();

                        if (!isIE10) {
                            $('.slide-item .video-background video').get(0).currentTime = 0;
                        }
                    }
                }


                function slideColAnimationEnded() {

                    animationInProgress = false;

                    playVideo()

                    if (isSafari) {
                        leftSideResize();
                    }


                    if (window.location.hash) {

                        if ($(window.location.hash).length) {
                            $('html, body').animate({
                                scrollTop: $(window.location.hash).offset().top
                            }, 500);
                        }
                    }
                }

                if (event.data.noAnimation) {
                    $('.animation-col').removeClass('noAnimation');
                    showContent();

                    if (isSafari) {
                        leftSideResize();
                    }
                }


                function hideContent() {
                    $('.content-slider .item').removeClass('active');
                    $('.slide-item').removeClass('active');

                    stopVideo();
                }

                function showContent() {

                    $('.content-slider .item:nth-child(' + nextSlide + ')').addClass('active');

                    $('.slide-item:eq(' + (nextSlide - 1) + ')', '.slides-list').addClass('active');
                }
            }


            function GridSlider(settings) {

                var _ = this;

                var SELECTOR = settings.selector;

                var IMG_PARTS_ROWS = $(SELECTOR).data('img-rows');

                this.COLOR_PARTS_ROWS = $(SELECTOR).data('color-rows');

                _.blockHeight = 0;

                var TOTAL_PARTS_ROWS = IMG_PARTS_ROWS + this.COLOR_PARTS_ROWS;
                var TOTAL_PARTS_COLS = $(SELECTOR).data('cols');

                var COLS_NUM = TOTAL_PARTS_ROWS * TOTAL_PARTS_COLS;


                _.create = function () {

                    var blocksList = createBlocks();

                    var colsList = sortByCols(blocksList);

                    // var shuffledColsList = shuffle(colsList);

                    addBlocks(colsList);

                    setSize();

                    $(window).on('resize', function () {
                        setSize();
                    })

                };


                _.animateGridCols = function (nextSlide) {

                    var colsCounter = 1;

                    $(SELECTOR).find('.animation-col').each(function () {

                        var $thisCol = $(this);

                        var animationColIndex = $thisCol.data('col');

                        var blockCounter = 1;

                        var blockIsSet = false;

                        var blocksNum = $thisCol.data('blocks-num');

                        var hiddenBlocksCounter = 1;

                        $(this).find('.block').each(function () {

                            var $thisBlock = $(this);
                            var blockPartCol = $thisBlock.data('slide-col');

                            if (blockIsSet) {
                                if (hiddenBlocksCounter++ < TOTAL_PARTS_ROWS) {
                                    $thisBlock.addClass('hidden');
                                }
                            }

                            if ($thisBlock.data('slide') == nextSlide) {

                                //mark active block in slide area
                                if (colsCounter <= TOTAL_PARTS_COLS) {
                                    blockIsSet = true;
                                }

                                var slideRow = $thisBlock.data('slide-row');

                                var transformY = -((blockCounter - slideRow) * (100 / blocksNum));


                                $thisCol.css({
                                    "transform": "translate3d(0," + transformY + "%, 0)"
                                });


                                var shift = 0;

                                //shift blocks to slide
                                if (animationColIndex > blockPartCol) {

                                    if (settings.extraColsSide == 'right') {
                                        shift = animationColIndex - blockPartCol;
                                    }
                                    else {
                                        shift = blockPartCol - animationColIndex;
                                    }


                                    $thisBlock.addClass('shifted');

                                    $thisBlock.css({
                                        "transform": "translate3d(" + -(shift * 100) + "%, 0, 0)"
                                    });

                                }

                                else if (animationColIndex < blockPartCol) {

                                    if (settings.extraColsSide == 'left') {
                                        shift = animationColIndex - blockPartCol;
                                    }
                                    else {
                                        shift = blockPartCol - animationColIndex;
                                    }


                                    $thisBlock.addClass('shifted');

                                    $thisBlock.css({
                                        "transform": "translate3d(" + (shift * 100) + "%, 0, 0)"
                                    });

                                }

                            }

                            blockCounter++;
                        })

                        colsCounter++;

                    });
                };


                function createBlocks() {

                    var blocksList = [];

                    var activeBlocks = 0;

                    var slideCounter = 1;
                    var blocksCounter = 1;

                    $(SELECTOR).find('.slide-item').each(function () {

                        var slideParts = [];


                        if (!$(this).hasClass('video')) {
                            $(this).css('background-image', 'url(' + $(this).data('img') + ')');
                        }

                        //create img blocks
                        for (var row = 1; row <= TOTAL_PARTS_ROWS; row++) {

                            for (var col = 1; col <= TOTAL_PARTS_COLS; col++) {

                                if (row <= IMG_PARTS_ROWS) {
                                    var imgBlock = '<div class="block imgBlock" data-img="' + $(this).data('img') + '" data-slide="' + slideCounter + '" data-slide-row="' + row + '" data-slide-col="' + col + '"></div>';

                                    slideParts.push(imgBlock);
                                }

                                else {
                                    var colorBlock = '<div class="block colorBlock" data-color="' + $(this).data('color') + '" data-slide="' + slideCounter + '" data-slide-row="' + row + '" data-slide-col="' + col + '"></div>';

                                    slideParts.push(colorBlock);
                                }

                                blocksCounter++;

                                activeBlocks++;


                            }
                        }


                        blocksList.push(slideParts);

                        slideCounter++;

                    });


                    return blocksList;

                }


                function addBlocks(blocksList) {

                    var startX = 0;

                    var colsWrap = $('<div class="cols-wrap"></div>').appendTo(SELECTOR);

                    for (var col = 0; col < blocksList.length; col++) {

                        var $thisCol = $('<div class="animation-col"></div>').appendTo(colsWrap);

                        $thisCol.attr('data-col', col + 1);

                        //set col height
                        // $thisCol.css({
                        //     "height": 100 * SLIDES_NUMBER / IMG_PARTS_ROWS + '%'
                        // });


                        //set side for extra cols
                        if (settings.extraColsSide == 'right') {
                            $thisCol.css({
                                "left": startX + "%"
                            });
                        }
                        else {
                            $thisCol.css({
                                "right": startX + "%"
                            });
                        }


                        for (var blockCounter = 0; blockCounter < blocksList[col].length; blockCounter++) {

                            var $thisBlock = $(blocksList[col][blockCounter]).appendTo($thisCol);

                            var $thisBlockRow = $thisBlock.data('slide-row');
                            var $thisBlockCol = $thisBlock.data('slide-col');


                            $thisCol.attr('data-blocks-num', blocksList[col].length);


                            var $thisBlockBg = $('<div></div>').appendTo($thisBlock);


                            if ($thisBlockRow > 1) {
                                $thisBlockBg.css('top', -100 * ($thisBlockRow - 1) + '%');
                            }


                            if (settings.extraColsSide == 'right') {
                                if ($thisBlockCol > 1) {
                                    $thisBlockBg.css('left', -100 * ($thisBlockCol - 1) + '%');
                                }
                            }
                            else {
                                if ($thisBlockCol > 1) {
                                    $thisBlockBg.css('right', -100 * ($thisBlockCol - 1) + '%');
                                }
                            }


                            //set img for img blocks
                            if ($thisBlock.hasClass('imgBlock')) {
                                $thisBlockBg.css('background-image', 'url(' + $thisBlock.attr('data-img') + ')');
                            }

                            //set backcolor for color blocks

                            if ($thisBlock.hasClass('colorBlock')) {
                                $thisBlock.css('background-color', $thisBlock.attr('data-color'));
                            }


                            //set block position index
                            $thisBlock.attr('data-index', blockCounter);


                            // //set block height
                            // $thisBlock.css({
                            //     "height": 100 / SLIDES_NUMBER + '%'
                            // });

                        }

                        startX = startX + 100 / TOTAL_PARTS_COLS;


                    }
                }

                function setSize() {


                    var sliderHeight = $(SELECTOR)[0].getBoundingClientRect().height;

                    _.blockHeight = sliderHeight / IMG_PARTS_ROWS;


                    $(SELECTOR + ' .block').height(_.blockHeight);


                }


                function sortByCols(blocksList) {

                    var colsList = [];

                    for (var col = 0; col < COLS_NUM; col++) {

                        var colList = [];

                        colsList.push(colList);

                        blocksList.forEach(function (item, i) {

                            colList.push(item[col]);
                        });

                        shuffle(colList);


                    }

                    return colsList;

                }


                function shuffle(a) {
                    var j, x, i;
                    for (i = a.length; i; i--) {
                        j = Math.floor(Math.random() * i);
                        x = a[i - 1];
                        a[i - 1] = a[j];
                        a[j] = x;
                    }

                    return a;
                }

            }
        }


        function Chart(el) {

            var options = {
                percent: el.getAttribute('data-percent') || 25,
                size: el.getAttribute('data-size') || 256,
                lineWidth: el.getAttribute('data-line') || 7,
                rotate: el.getAttribute('data-rotate') || 0,
                label: el.getAttribute('data-label') || '',
                strokeBackgroundColor: el.getAttribute('data-stroke-background-color') || '',
                strokeColor: el.getAttribute('data-stroke-color') || ''
            }


            var canvas = document.createElement('canvas');

            var chartInfo = document.createElement('div');
            chartInfo.className = 'chart-info';

            var spanPercent = document.createElement('div');
            spanPercent.className = 'chart-percent';

            var spanLabel = document.createElement('div');
            spanLabel.className = 'chart-label';


            spanPercent.textContent = options.percent + '%';
            spanLabel.textContent = options.label;


            el.appendChild(chartInfo);
            chartInfo.appendChild(spanPercent);

            if (options.label) {
                chartInfo.appendChild(spanLabel);
            }

            el.appendChild(canvas);

            if (typeof(G_vmlCanvasManager) !== 'undefined') {
                G_vmlCanvasManager.initElement(canvas);
            }

            var ctx = canvas.getContext('2d');


            drawChart();


            // window.addEventListener('resize', function(event){
            //     drawChart();
            // });


            function drawChart() {

                var elWidth = el.offsetWidth;

                canvas.width = canvas.height = options.size;

                ctx.translate(options.size / 2, options.size / 2); // change center
                ctx.rotate((-1 / 2 + options.rotate / 180) * Math.PI); // rotate -90 deg

                var radius = (options.size - options.lineWidth) / 2;

                var drawCircle = function (color, lineWidth, percent) {
                    percent = Math.min(Math.max(0, percent || 1), 1);
                    ctx.beginPath();
                    ctx.arc(0, 0, radius, 0, Math.PI * 2 * percent, false);
                    ctx.strokeStyle = color;
                    // ctx.lineCap = 'round'; // butt, round or square
                    ctx.lineWidth = lineWidth
                    ctx.stroke();
                };

                if (options.strokeBackgroundColor) {
                    drawCircle(options.strokeBackgroundColor, 4, 100 / 100);
                }

                drawCircle(options.strokeColor, options.lineWidth, options.percent / 100);
            }
        }


        function initCharts() {

            var charts = document.getElementsByClassName("circle-chart");

            for (var i = 0; i < charts.length; i++) {

                var item = charts[i];

                var chart = [];

                chart[i] = new Chart(item);

            }


        }


        initCharts();


    });


    //************************************
    // RESIZE CONTENT BLOCK FOR SAFARI
    //************************************


    if (isSafari) {

        $('body').addClass('safari');

        $(window).resize(function () {
            if (this.resizeTO) clearTimeout(this.resizeTO);
            this.resizeTO = setTimeout(function () {
                $(this).trigger('resizeEnd');
            }, 500);
        });


        $(window).bind('resizeEnd', function () {
                leftSideResize();
        });

        $(window).on('load', function () {
            setTimeout(function(){
                leftSideResize();
            }, 1500)
        });


        $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
            leftSideResize();
        })

    }

    function leftSideResize() {

        var ww = $(window).width();

        if (ww <= 650) {

        }

        else {

            var rightSideTopPartHeight = $('.sides-wrap .right-side .top-part').outerHeight();
            var rightSideContentHeight = $('.sides-wrap .right-side .bottom-part .content-slider').outerHeight();

            var rightSideHeight = rightSideTopPartHeight + rightSideContentHeight;

            var leftSideTopPartHeight = $('.sides-wrap .left-side .top-part').outerHeight();


            $('.sides-wrap .left-side .bottom-part .content-slider').height(rightSideHeight - leftSideTopPartHeight);


            setTimeout(function () {
                $('body').css('overflow', 'auto');
            }, 500);
        }
    }


    //************************************
    // AUTO PLAY VIDEO
    //************************************

    $(".page-block.video-block").hover(
        function () {
            $('.video-background.active-hover video', this).get(0).pause();
        }, function () {
            $('.video-background.active-hover video', this).get(0).play();
        });


    //************************************
    // MAIN NAV
    //************************************


    function initDropdownToggle() {


        $('.navbar-nav .menu-item-has-children').each(function () {

            var $this = $(this);

            var $sub_menu = $this.find('.sub-menu');


            var toggleButton = $('<button class="dropdownToggle"> <i class="icon icon-angle-right"></i> </button>');

            var closeButton = $('<button class="close"> <i class="icon icon-angle-left"></i> </button>');

            $this.find('>a').after(toggleButton);

            $sub_menu.prepend(closeButton);


            if (Modernizr.touch) {
                toggleButton.on('click',
                    function () {

                        if (!$this.hasClass("open")) {
                            TweenMax.set($sub_menu, {height: "auto", autoAlpha: 1});
                            TweenMax.from($sub_menu, 0.5, {autoAlpha: 0, height: 0});

                            $this.addClass("open");
                        }

                        else {
                            TweenMax.to($sub_menu, 0.5, {
                                height: 0, autoAlpha: 0
                            });
                            $this.removeClass("open");

                        }
                    })

                closeButton.on('click', function () {

                    $this.removeClass("open");

                })
            }

            else {
                $this.hover(
                    function () {
                        if (!$this.hasClass("open")) {
                            TweenMax.set($sub_menu, {height: "auto", autoAlpha: 1});
                            TweenMax.from($sub_menu, 0.5, {autoAlpha: 0, height: 0});

                            $this.addClass("open");
                        }
                    }, function () {
                        if ($this.hasClass("open")) {
                            TweenMax.to($sub_menu, 0.5, {
                                height: 0, autoAlpha: 0
                            });
                            $this.removeClass("open");
                        }
                    }
                );
            }

        })
    }

    initDropdownToggle();


    TweenMax.set('.animated-counter circle', {drawSVG: 0});

    function decimalPlaces(num) {
        var match = (''+num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
        if (!match) { return 0; }
        return Math.max(
            0,
            // Number of digits right of decimal point.
            (match[1] ? match[1].length : 0)
                // Adjust for scientific notation.
            - (match[2] ? +match[2] : 0));
    }


    function is_on_screen_counter() {

        $(".content-slider .item.active .animated-counter:not('.shown')").each(function () {

            var counter = {val: 0};

            var _ = $(this);


            if (_.isOnScreen(1, 1)) {

                _.addClass('shown');

                var _number = _.find('.count-val');

                var _numberValue = _number.data('number');

                var _circle = _.find('circle');


                TweenLite.to(counter, 1, {
                    val: _numberValue,
                    //roundProps: "val",
                    onUpdate: updateHandler,
                    ease: Linear.easeNone
                });


                TweenMax.fromTo(_circle, 1, {drawSVG: "0"}, {drawSVG: '0 100%', ease: Linear.easeNone});

                function updateHandler() {
                    var value = counter.val.toFixed(decimalPlaces(_numberValue));
                    var num = value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
                    _number.text(num);
                }
            }

        });
    }


    $(document).scroll(function (event) {
        is_on_screen_counter();
    });


    //************************************
    // YOUTUBE VIDEO IN MODAL
    //************************************

    $('.modal-yt-toggle').on('click', function () {

        var _ = $(this);

        var _id = _.data('yt-id');

        if (_id != ytPlayer.getVideoData()['video_id']) {
            ytPlayer.loadVideoById(_id);
        }


    });


    $(document).ready(function () {

        $('#yt-modal').on('shown.bs.modal', function (e) {
            ytPlayer.playVideo();
        })

        $('#yt-modal').on('hide.bs.modal', function (e) {
            ytPlayer.pauseVideo();
        })


    });


    //************************************
    // VIMEO VIDEO IN MODAL
    //************************************


    $(document).ready(function () {

        var player;

        var isPlayerInit = false;

        $('.modal-vimeo-toggle').on('click', function () {

            var _ = $(this);

            var _id = parseInt(_.data('vim-id'));

            if (isPlayerInit) {

                player.getVideoId().then(function(id) {

                    if (_id != id) {

                        console.log(id);
                        player.loadVideo(_id);
                    }

                }).catch(function(error) {
                    console.log(error);
                });
            }

            else {

                var options = {
                    id: _id
                };

                player = new Vimeo.Player('vimeo-video', options);

                isPlayerInit = true;
            }

        });

        $('#vimeo-modal').on('shown.bs.modal', function (e) {
            player.play();
        })

        $('#vimeo-modal').on('hide.bs.modal', function (e) {
            player.pause();
        })

    });

})(jQuery);

